/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PatientCalendar = {
    properties: {
        id: {
    type: 'number',
},
        companyID: {
    type: 'number',
    isRequired: true,
},
        createdByID: {
    type: 'number',
    isRequired: true,
},
        title: {
    type: 'string',
    isRequired: true,
},
        description: {
    type: 'string',
    isRequired: true,
},
        date: {
    type: 'string',
    isRequired: true,
},
        time: {
    type: 'string',
    isRequired: true,
},
        eventTypeID: {
    type: 'number',
    isRequired: true,
},
        patient: {
    type: 'string',
    isRequired: true,
},
        location: {
    type: 'string',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    isRequired: true,
},
    },
};